import type { PointCloudParser } from '../../hooks/useSupabaseSceneDetail';
// createParser accepts a broader set than the DB SceneFileType because it
// handles file-extension aliases (laz → las, tif/tiff → dem) at runtime.
import { parseLas } from './parseLas';
import { parseDem } from './parseDem';

/**
 * Create a parser for the given file type.
 *
 * Supported formats:
 *   - 'las' / 'laz' → loaders.gl LAS/LAZ parser (sync, no workers)
 *   - 'tif' / 'tiff' → geotiff DEM parser (async)
 *   - 'asc' / 'csv' → not yet implemented (throws)
 */
export function createParser(fileType: string): PointCloudParser {
  switch (fileType) {
    case 'las':
    case 'laz':
      return async (buffer, _ft) => parseLas(buffer);
    case 'tif':
    case 'tiff':
    case 'dem':
      return async (buffer, _ft) => parseDem(buffer);
    case 'asc':
    case 'csv':
      return async (_buffer, ft) => {
        throw new Error(
          `Parser for "${ft}" is not yet implemented. ` +
            'Supported formats: las, laz, tif, tiff.',
        );
      };
    default:
      return async (_buffer, ft) => {
        throw new Error(`Unsupported file type: "${ft}"`);
      };
  }
}

/** Convenience parser that auto-detects format from the file_type field. */
export const autoParser: PointCloudParser = async (buffer, fileType) => {
  const parser = createParser(fileType);
  return parser(buffer, fileType);
};

export { parseLas, parseDem };
